<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">数据</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body">

          <el-table v-loading="tableLoading"  :data="tableData" :height="400" border style="width: 100%; max-height: 500px ;overflow-y: auto">

            <el-table-column prop="testTime" :formatter="getTestTime" label="测量时间"></el-table-column>

<!--            <el-table-column prop="foodstatus" :formatter="getFoodstatus" label="血糖测量时间段" ></el-table-column>-->
<!--            <el-table-column prop="aimstatus" :formatter="getAimstatus" label="测量结果" ></el-table-column>-->
            <el-table-column prop="" label="正常数值(mmol/L)" :formatter="getNormalValue" ></el-table-column>

            <el-table-column prop="result"  label="血糖数值(mmol/L)" ></el-table-column>

          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>

      </div>
    </div>





  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: "QZXueTangYiData",
  data() {
    return {
      tableLoading:false,
      userCode: '',
      deviceType: '',

      pageIndex:1,
      pageSize:20,
      tableData:[],
      totalItems: 0,
      currentPage:1,

    }
  },
  components: {

  },

  methods: {
    init(userCode,deviceType) {
      this.userCode = userCode;
      this.deviceType = deviceType;
      this.getXueTangData();
    },
    closeSelf() {
      this.$emit("closeQZXueTangYiData");
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getXueTangData();
    },
    getTestTime(row){
      return timefilters(row.testTime)
    },

    getFoodstatus(row){
      if(row.foodstatus==0){
        return '餐前';
      }else
      if(row.foodstatus==1){
        return '餐后';
      }else
      if(row.foodstatus==2){
        return '随机';
      }else {
        return '随机';
      }
    },
    getNormalValue2(row){
      if(row.foodstatus==0){
        return '3.9-6.1';
      }else
      if(row.foodstatus==1){
        return '3.9-7.8';
      }else
      if(row.foodstatus==2){
        return '3.9-7.8';
      }else {
        return '3.9-7.8';
      }
    },
    getNormalValue(row){
        return '3.9-7.8';
    },
    getAimstatus(row){
      if(row.aimstatus==='1'){
        return '偏低';
      }
      if(row.aimstatus==='3'){
        return '正常';
      }
      if(row.aimstatus==='5'){
        return '偏高';
      }
    },

    getXueTangData(){

      let dt = "";
      if(this.deviceType ==1){
        dt = "SanNuo";
      }
      if(this.deviceType ==2){
        dt = "AAL";
      }

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "DataAll/PageByUserCodeDeviceTypeValueType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          userCode: this.userCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          deviceType:dt,
          valueType:4,
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.tableData=response.data.data.pageInfo.list;
              this.totalItems=response.data.data.pageInfo.total
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },


  }


}
</script>

<style lang="scss" scoped>


</style>
